import * as React from "react";
import {TextInput} from "../text/TextInput";
import {IconButton} from "../../button/IconButton";

interface IPasswordInputProps {
	readonly value?: string;
	readonly onInput: (val: string) => void;
	readonly infoText?: string;
	readonly placeholder?: string;
	readonly isTooltip?: boolean;
	readonly isTextInfo?: boolean;
	readonly divRef?: React.RefObject<HTMLDivElement>;
}

interface IPasswordInputState {
	hidePassword: boolean;
}

export class PasswordInput extends React.Component<IPasswordInputProps, IPasswordInputState> {
	private _ref = React.createRef<HTMLInputElement | HTMLTextAreaElement>();
	constructor(props: IPasswordInputProps) {
		super(props);

		this.state = {
			hidePassword: true,
		};
	}

	private toggleHiding = () => {
		this.setState((prevState) => ({hidePassword: !prevState.hidePassword}));
	};

	public override render() {
		const {value, placeholder, infoText, isTooltip, isTextInfo, divRef} = this.props;
		const {hidePassword} = this.state;

		return (
			<div className="PasswordInput hbox alignCenter">
				{isTooltip ? (
					<TextInput
						value={value}
						onInput={(val) => this.props.onInput(val)}
						inputType={hidePassword ? "password" : "text"}
						placeholder={placeholder}
						errorMessage={infoText}
						isTextInfo={isTextInfo}
						className="passwordInput"
					/>
				) : (
					<TextInput
						value={value}
						onInput={(val) => this.props.onInput(val)}
						inputType={hidePassword ? "password" : "text"}
						placeholder={placeholder}
						errorMessage={infoText}
						isTextInfo={isTextInfo}
						divRef={(divRef as React.RefObject<HTMLInputElement>) ?? (this._ref as React.RefObject<HTMLInputElement>)}
						className="passwordInput"
					/>
				)}
				<IconButton
					icon={hidePassword ? "hide-active" : "hide"}
					onClick={this.toggleHiding}
				/>
			</div>
		);
	}
}
